import { AxiosError, AxiosResponse } from 'axios'
import { Query } from '@tanstack/vue-query'
import { Ref } from 'vue'

export type RefetchIntervalFn<T> = (
  data: T | undefined,
  query: Query<T, AxiosError>,
) => number | false

/**
 * Creates a TanStack Query refetch interval handler that stops polling after
 * the first settled error and flips the provided flag for downstream UI state.
 */
export function createRefetchIntervalFn<T>(refetchTimeout: number, refreshError: Ref<boolean>) {
  return (
    _data: AxiosResponse<T> | undefined,
    query: Query<AxiosResponse<T>, AxiosError>,
  ): number | false => {
    const { status, fetchStatus } = query.state
    if (status === 'error' && fetchStatus === 'idle') {
      refreshError.value = true
    }

    if (!refreshError.value && fetchStatus === 'idle') {
      return refetchTimeout
    }

    return false
  }
}
